import React from 'react';
import { useNavigate } from 'react-router';
import './BookDetails.css';


const BookDetails = () => {
  const navigate = useNavigate(); // we make a variable that points at the function

  const handleClick = (path) => { // and when someone clicks on the button
    navigate(path); // we navigate to the path defined
  };
  const openInNewTab = (url) => { // same as handleClick but opens the link in a new tab
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  return (
    <section id="book-details" className="book-details">
      <div className="book-details_content">
        <div className="book-details_text">
          <h3 className="section_title">
            Children of Nemia is available today
          </h3>
          <p><strong><a href="https://thearcanist.net/nemia/" target="blank">Browse editions</a></strong></p>
          <p className="body_text">

            <strong>On the eve of Nemia’s Journey of Patronage,</strong> fifteen-year-old Van is determined to prove himself by returning home as a blooded member of his tribe–assuming he survives the ordeal. As the chieftain’s son, Van will strive to earn his father’s respect by extending a hand in friendship to Simon, a fast-talking sorcerer from a land across the sea, and Shale, a mysterious visitor dubbed a dread omen by the tribe’s shamans.
            <br></br><br></br>
            What begins as a simple act of generosity blossoms into a connection that will shape Van’s future and reveal dangerous secrets about what he was raised to believe. With help from his new friends, Van will seek the truth behind his ancestors’ ancient conspiracy and the present-day schemes of the four tribes, all while privately healing from the heartbreak of unexpected first love. Together, can they save Nemia? Is the cost of salvation worth paying?
            <br></br><br></br>
            A shadow darkens Nemia on the year of the pilgrimage. Forces conspire to extort the outcome of the once-peaceful Journey of Patronage. Deadly beasts, treachery among the tribes, and a cosmic evil referring to itself only as “Anathema” align to threaten the harmony of Van’s life as he knows it. Or perhaps all of life itself.
            <br></br><br></br>
            <strong>Children of Nemia</strong> is a coming of age fantasy epic about self-discovery, forgiveness, and choosing hope over helplessness.

          </p>

          {/* <label for="retailers" id="retailers">Select your retailer:</label>
          <select name="retailers" id="retailers-option">
            <option value="Amazon">Amazon (Kindle)</option>
            <option value="Apple">Apple Books</option>
            <option value="Google">Google</option>
            <option value="Kobo">Kobo</option>
            <option value="BarnesNoble">Barnes & Noble</option>
          </select> */}

          {/* <h3><a href="/read" target="_blank" rel="noopener noreferrer">Read the first chapter</a></h3> */}
        </div>
        <div className="book-details_image">
          <span onClick={() => openInNewTab('/images/CoN%20-%201920x1080.jpeg')}>
            <img width="250px" src="images/CoN_cover_web.jpeg" alt="Children of Nemia" />
          </span>
            <br />
          <div class = "book_buttons">
          <a href="https://www.amazon.com/dp/B0FZC6DSC4" target="blank"><img width="100px" src="images/amazon_1.png" alt="Available at Amazon" /></a>
          <a href="https://www.goodreads.com/book/show/243513957-children-of-nemia" target="blank"><img width="100px" src="images/goodreads_1.png" alt="Add to Goodreads" /></a>
          </div>
        </div>

      </div>
    </section>
  )
}

export default BookDetails;
